import { Box } from '@dtx-company/design-system/src/components/Box/Box'
import { CategoriesList } from '../../../components/MergedStore/Category/CategoriesList/CategoriesList'
import { CategoryLandingProps } from './CategoryLanding.types'
import { ENABLE_MERGED_STORE_FLOWTAG_BTM_BANNER } from '@dtx-company/true-common/src/constants/featureFlags'
import { FC, useCallback, useEffect, useState } from 'react'
import { MergedStoreCategoryBottomBanner } from '../../../components/MergedStore/Category/BottomBanner/BottomBanner'
import { MergedStoreCategoryProductFeatures } from '../../../components/MergedStore/Category/ProductFeatures/ProductFeatures'
import { MergedStoreCategoryTopBanner } from '../../../components/MergedStore/Category/TopBanner/CategoryTopBanner'
import { PrintStoreContainer } from '../../print-store/PrintStoreContainer'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import Cookies from 'universal-cookie'

const cookies = new Cookies()
const scrollPositionCookieKey = 'store_categories_list_scroll_height'

export const CategoryLanding: FC<{ data: CategoryLandingProps }> = ({ data }) => {
  const [loaded, setLoaded] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [enabledBtmBanner] = useFlowFeature(ENABLE_MERGED_STORE_FLOWTAG_BTM_BANNER)

  const setCookie = useCallback((): void => {
    cookies.set(scrollPositionCookieKey, window.scrollY)
  }, [])

  useEffect(() => {
    history.scrollRestoration = 'manual'
    return () => {
      history.scrollRestoration = 'auto'
    }
  }, [])

  useEffect(() => {
    if (data) {
      window.addEventListener('scroll', setCookie)
      setLoaded(true)
    }
    return () => window.removeEventListener('scroll', setCookie)
  }, [data, setCookie])

  useEffect(() => {
    if (loaded && !scrolled) {
      const height = cookies.get(scrollPositionCookieKey)
      window.scrollTo({ top: height })
      setScrolled(true)
    }
  }, [loaded, scrolled])

  return (
    <PrintStoreContainer>
      <MergedStoreCategoryTopBanner
        topbannertitle={data.topbannertitle}
        topbannerdescription={data.topbannerdescription}
        topbannerimage={data.topbannerimage}
        topbannerimagemobile={data.topbannerimagemobile}
        topbannerimagetablet={data.topbannerimagetablet}
      />
      <CategoriesList />
      <Box
        sx={{
          mt: { xs: 8.5, md: 11, lg: 13 },
          mb: { xs: 7.5, md: 9.5, lg: 12.5 }
        }}
      >
        <MergedStoreCategoryProductFeatures features={data.features} />
      </Box>
      {enabledBtmBanner && (
        <MergedStoreCategoryBottomBanner
          bottombannertitle={data.bottombannertitle}
          bottombannerdescription={data.bottombannerdescription}
          bottombannerimage={data.bottombannerimage}
          bottombannerimagetablet={data.bottombannerimagetablet}
          bottombannerimagemobile={data.bottombannerimagemobile}
        />
      )}
    </PrintStoreContainer>
  )
}
